
import Template from "../Template/Template";


export default function Custom() {
	
	return (
		<Template type={"custom"} />
	);
}